<template>
  <div class="container text-center py-3">
    <h2>Aplikacija KUP</h2>
    <div class="container">
      <p class="text-justify lead">
        Aplikacija <strong>KUP</strong> omogućava <em>online</em> vođenje kase
        <em>(blagajne)</em> uzajamne pomoći, vođenje podataka o članovima,
        pregled obustava na plaći, pregled kartica korisnika i drugih
        knjigovodstvenih podataka.
        <br />
        Ovo programsko rješenje moguće je prilagoditi svakom klijentu ovisno o
        specifičnim potrebama ili posebnim uvjetima iz pravlinika o radu
        blagajne uzajamne pomoći.
      </p>
      <div class="row text-left pl-3">
        <div class="col-sm-4">
          <label><strong>Sprecifikacija aplikacije:</strong></label>
          <ul>
            <li><label>Evidencija korisnika</label></li>
            <li><label>Evidencija pozajmica</label></li>
            <li><label>Uplate uloga</label></li>
            <li><label>Otplate pozajmica</label></li>
            <li><label>Kartica korisnika</label></li>
            <li><label>Mjesečne isplate</label></li>
            <li><label>Financijske kartice</label></li>
            <li><label>Temeljnice</label></li>
            <li><label>Izvještaji</label></li>
            <li><label>Bilanca</label></li>
          </ul>
        </div>
        <div class="col-sm-8 text-center pt-5">
          <img
            class="img-fluid"
            src="../../assets/img/kup/kup-mockup.png"
            alt="kup"
          />
        </div>
      </div>
      <div class="text-left p-5">
        <div>
          <a href="./kup/uputa" title="KUP - uputa za korištenje"><icon name="question-circle" scale="2" /><span class="p-2">UPUTA ZA KORIŠTENJE</span></a>
        </div>
        <p class="pt-3">
          Za više informacija o aplikaciji pošaljite upit na
          <a :href="`mailto:${constants.email}`" :title="constants.email">
            {{ constants.email }}</a
          >
        </p>
      </div>
      <div class="mt-5 mb-5 text-center">
        <div class="row">
          <div class="col-md-4 p-2">
            <img
              class="img-fluid shadow"
              src="../../assets/img/kup/app/01.png"
              alt="kup"
            />
          </div>
          <div class="col-sm-4 p-2">
            <img
              class="img-fluid shadow"
              src="../../assets/img/kup/app/02.png"
              alt="kup"
            />
          </div>
          <div class="col-sm-4 p-2">
            <img
              class="img-fluid shadow"
              src="../../assets/img/kup/app/03.png"
              alt="kup"
            />
          </div>
          <div class="col-sm-4 p-2">
            <img
              class="img-fluid shadow"
              src="../../assets/img/kup/app/04.png"
              alt="kup"
            />
          </div>
          <div class="col-sm-4 p-2">
            <img
              class="img-fluid shadow"
              src="../../assets/img/kup/app/05.png"
              alt="kup"
            />
          </div>
          <div class="col-sm-4 p-2">
            <img
              class="img-fluid shadow"
              src="../../assets/img/kup/app/06.png"
              alt="kup"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  metaInfo: {
    titleTemplate: "%s | KUP",
    meta: [
      {
        name: "description",
        content: "KUP - Kasa uzajamne pomoće",
      },
    ],
  },
  data() {
    return {
      constants: this.$constants,
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/kup/home.vue